// src/components/JobView/Tabs/Modals/MultiUserSelect.js
// Selector compacto de VARIOS usuarios (checkboxes en un desplegable).
import React, { useState, useRef, useEffect } from 'react';
import { userLabel } from '../../../../utils/taskAssignment';

const MultiUserSelect = ({ users = [], selectedIds = [], onChange, placeholder = 'Asignar a...' }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const toggle = (id) => {
        if (selectedIds.includes(id)) onChange(selectedIds.filter(x => x !== id));
        else onChange([...selectedIds, id]);
    };

    const labels = users.filter(u => selectedIds.includes(u.id)).map(userLabel);

    return (
        <div className="relative" ref={ref}>
            <button
                type="button"
                onClick={() => setOpen(o => !o)}
                className="text-xs border border-gray-300 rounded-md px-2 py-1 bg-white min-w-[130px] max-w-[180px] text-left truncate"
                title={labels.join(', ')}
            >
                {labels.length ? labels.join(', ') : <span className="text-gray-400">{placeholder}</span>}
            </button>
            {open && (
                <div className="absolute right-0 z-30 mt-1 w-56 max-h-52 overflow-y-auto bg-white border rounded-md shadow-lg p-1">
                    {users.length === 0 && <p className="text-xs text-gray-400 px-2 py-1">No hay usuarios.</p>}
                    {users.map(u => (
                        <label key={u.id} className="flex items-center gap-2 px-2 py-1 hover:bg-gray-50 rounded cursor-pointer text-sm">
                            <input type="checkbox" checked={selectedIds.includes(u.id)} onChange={() => toggle(u.id)} />
                            {userLabel(u)}
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MultiUserSelect;
